import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import {Button, Col, Container, Row} from "reactstrap";
import DataWrapper from '../../principal/containers/DataWrapper'
import FiltroBloqueioBl from '../components/FiltrosBloqueioBl'
import BloqueioBlStore from '../stores/BloqueioBlStore';
import BloqueioCadastrar from '../components/BloqueioCadastrar'
import Footer from '../../comum/components/Footer';
import FooterContent from '../../comum/components/FooterContent';
import FooterOptions from '../../comum/components/FooterOptions';
import IconButton from '../../comum/components/IconButton';
import TabelaBloqueioBl from '../components/TabelaBloqueioBl';
import ModalAviso from '../../comum/components/ModalAviso';
import ExportaExcelBloqueioBl from '../components/ExportaExcelBloqueioBl';
import { makePDF } from '../../../utils/formatar';
import ModalForm from '../../comum/components/ModalForm';
import { IconeCarregar } from '../../comum/components/Icones';

@inject("store")
@DataWrapper
@observer
export class BloqueioBl extends Component {
    constructor(props) {
        super(props)
        this.tituloPaginaStore = this.props.store.tituloPaginaStore
        this.loginStore = this.props.store.loginStore

        this.controller = new BloqueioBlStore()
        
    }
  
    can = (operacao = "C", tarefa = "BloqueioDesdobramentoBL") => this.loginStore.can(tarefa, operacao)

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Bloqueio de Desdobramento BL")
    }

    bloqueioCadastrar = () => {
        if(this.controller.novoBloqueio)
            return <BloqueioCadastrar 
                controller={this.controller}
            />
    }

    bloqueioEditar = () => {
        if(this.controller.isEditando)
            return <BloqueioCadastrar 
                controller={this.controller}
            />
    }

    aviso = () => {
        if(this.controller.mensagens.length > 0){
            return <ModalAviso onClickFechar={ this.fecharAviso }>
                 { this.controller.mensagens.map((msg, x) =>
                    <h2 key={x}>{ msg }</h2>
                )
            }
            </ModalAviso>
        }
    }

    modalApagar = () => {
        if(this.controller.modalConfirmaApagar){
            return <ModalForm
                onClickCancelar={ () => this.controller.cancelarApagarBloqueio() }
                onClickSalvar={ () => this.controller.apagarBloqueio() }
                labelConfirmar = {this.controller.apagando ? <IconeCarregar tamanho="2x" /> :"SIM"}
                labelCancelar = "NÃO"
            >
                <h2>Confirma apagar o bloqueio?</h2>
            </ModalForm>
        }
    }

    fecharAviso = () => {
        this.controller.mensagens = []
        this.sucessoInserir = false
        if(this.controller.clickFiltrar)
            this.controller.listarBls()
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.can("I") && this.bloqueioCadastrar()}
                {this.can("A") && this.bloqueioEditar()}
                {this.can("E") && this.modalApagar()}
                {this.aviso()}
                <Container className="bloqueiobl" fluid>
                    <Row className="botao-novobloq">
                        <Col xs={12} sm={12} md={12} >
                            <Button className="btn-com-bordas-primary" onClick={this.controller.showAdicionarBloqueio}>Novo Bloqueio</Button>
                        </Col>
                    </Row>
                    <FiltroBloqueioBl controller={this.controller} />
                    <TabelaBloqueioBl controller={this.controller} />
                </Container>
                <Footer>
                    <FooterContent>
                        <div className="justify-content-between">
                            {this.controller.bloqueios.length > 0
                            && <div>
                                    <b>{this.controller.bloqueios.length}</b> Registros no Total
                                        <React.Fragment>
                                            - <a onClick={ () => this.controller.listarBls()} >Atualizar Lista</a>
                                        </React.Fragment>
                                </div>
                            }
                        </div>
                    </FooterContent>
                    <FooterOptions>
                        <IconButton 
                            icon="file-pdf"
                            text="Baixar PDF"
                            size="md"
                            disabled={this.controller.bloqueios.length === 0}
                            onClick={() => makePDF(
                                this.controller.bloqueios,
                                this.controller.todasColunas.map(elem => elem.dataField,"IdOperacao"),
                                this.controller.todasColunas.map(elem => elem.text),
                                ["DataInclusao"],
                                [{input: 'NomeNavio', append: 'IdOperacao'}],
                                false,
                                {nomeDoArquivo: "BloqueiosDesdobramentosBL.pdf"}
                            )}
                        />
                        <ExportaExcelBloqueioBl controller={this.controller} />
                    </FooterOptions>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bloqueiobl/telas/BloqueioBl.js